import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import { makeStyles } from '@material-ui/core'
import { INTERVALO_ACTUALIZACION } from '../../../../config/settings'
import { obtenerMonitorPorBuque, actualizarEmbarqueExportador, actualizarMonitorBodega, obtenerPlanDeEmbarqueActivo } from '../../actions'
import TotalPorBuque from '../../components/supervisionEmbarque/TotalPorBuque'
import TablaMonitorPorExportador from '../../components/supervisionEmbarque/TablaMonitorPorExportador'
import TablaMonitorPorBodegaDestino from '../../components/supervisionEmbarque/TablaMonitorPorBodegaDestino'
import TablaPlanDeEmbarqueActivo from '../../components/supervisionEmbarque/TablaPlanDeEmbarqueActivo'
import UltimaActualizacionData from '../../../Utils/containers/UltimaActualizacionDatos'
import { COLORES } from '../../../../config/colores'

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: COLORES.black,
    borderRadius: '22px',
    minHeight: '88vh',
    marginTop: '-3.5%',
    padding: '18px',
    color: 'white'
  }
}))

function SupervisionEmbarque (props) {
  const { obtenerMonitorPorBuque, actualizarEmbarqueExportador, actualizarMonitorBodega, obtenerPlanDeEmbarqueActivo } = props
  const [seconds, setSeconds] = useState(0)
  const [ultimaActualizacion, setUltimaActualizacion] = useState(new Date())
  const classes = useStyles()

  useEffect(() => {
    obtenerMonitorPorBuque()
    actualizarEmbarqueExportador()
    actualizarMonitorBodega()
    obtenerPlanDeEmbarqueActivo('white')

    const interval = setInterval(() => {
      setUltimaActualizacion(new Date())
      obtenerMonitorPorBuque()
      actualizarEmbarqueExportador()
      actualizarMonitorBodega()
      obtenerPlanDeEmbarqueActivo('white')
    }, INTERVALO_ACTUALIZACION)

    return () => {
      clearInterval(interval)
    }
  }, [obtenerMonitorPorBuque, actualizarEmbarqueExportador, actualizarMonitorBodega, obtenerPlanDeEmbarqueActivo])

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
    }, [1000])

    return () => {
      clearInterval(interval)
    }
  }, [setSeconds, seconds])

  const actualizar = () => {
    obtenerMonitorPorBuque()
    actualizarEmbarqueExportador()
    actualizarMonitorBodega()
    obtenerPlanDeEmbarqueActivo('white')
  }
  const actualizacion = () => {
    setSeconds(30)
    actualizar()
    setUltimaActualizacion(new Date())
  }

  return (
    <div className={classes.container}>
      <h4 style={{ margin: '1.5%' }}>Supervisión de embarque</h4>

      <UltimaActualizacionData
        actualizar={actualizacion}
        ultimaActualizacion={ultimaActualizacion}
        setUltimaActualizacion={setUltimaActualizacion}
        iconColor='white'
      />

      <Row>
        <Col md={3} style={{ margin: '2% auto 0 auto', width: '98%' }}>
          <TotalPorBuque totalPorBuque={props.totalPorBuque} />
        </Col>
        <Col md={9}>
          <TablaMonitorPorExportador />
          <TablaMonitorPorBodegaDestino />
          <TablaPlanDeEmbarqueActivo />
        </Col>

      </Row>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    totalPorBuque: state.embarque.totalPorBuque
  }
}
const mapActionsToProps = {
  actualizarEmbarqueExportador,
  actualizarMonitorBodega,
  obtenerMonitorPorBuque,
  obtenerPlanDeEmbarqueActivo
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(SupervisionEmbarque)
